import { render, staticRenderFns } from "./SubMenuMobile.vue?vue&type=template&id=36bf64b8"
import script from "./SubMenuMobile.vue?vue&type=script&lang=js"
export * from "./SubMenuMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports